import React from 'react';
import { motion } from 'framer-motion';
import PropTypes from 'prop-types';
import { useTranslations } from 'next-intl';

import { StyledTimeline } from './Timeline';

const TimelineAnimation = ({ onAnimationComplete }) => {
  const t = useTranslations();
  return (
    <StyledTimeline>
      <div className="timeline__wrapper">
        <motion.div
          className="timeline__content"
          initial={{ x: 'calc(-50% - 0px)' }}
          animate={{ x: 'calc(-50% + 2839px)' }}
          transition={{ ease: 'linear', duration: 4 }}
          onAnimationComplete={onAnimationComplete}
        >
          <hr className="timeline__horizontal-line" style={{ width: '4839px' }} />
          <div className="timeline__marker-wrapper" style={{ right: '10px' }}>
            <span className="timeline__marker-year">{t('archive.transition.timelineSlogan1')}</span>
          </div>
          <div className="timeline__date" style={{ right: '150px' }} />
          <div className="timeline__date" style={{ right: '300px' }} />
          <div className="timeline__date" style={{ right: '450px' }} />
          <div className="timeline__date" style={{ right: '600px' }} />
          <div className="timeline__marker-wrapper" style={{ right: '680px' }}>
            <span className="timeline__marker-year">{t('archive.transition.timelineSlogan3')}</span>
          </div>
          <div className="timeline__date" style={{ right: '750px' }} />
          <div className="timeline__date" style={{ right: '900px' }} />
          <div className="timeline__date" style={{ right: '930px' }} />
          <div className="timeline__date" style={{ right: '960px' }} />
          <div className="timeline__date" style={{ right: '990px' }} />
          <div className="timeline__date" style={{ right: '1140px' }} />
          <div className="timeline__date" style={{ right: '1290px' }} />
          <div className="timeline__date" style={{ right: '1440px' }} />
          <div className="timeline__date" style={{ right: '1470px' }} />
          <div className="timeline__marker-wrapper" style={{ right: '1500px' }}>
            <span className="timeline__marker-year">{t('archive.transition.timelineSlogan2')}</span>
          </div>
          <div className="timeline__date" style={{ right: '1620px' }} />
          <div className="timeline__date" style={{ right: '1770px' }} />
          <div className="timeline__date" style={{ right: '1800px' }} />
          <div className="timeline__date" style={{ right: '1950px' }} />
          <div className="timeline__date" style={{ right: '2100px' }} />
          <div className="timeline__marker-wrapper" style={{ right: '2130px' }}>
            <span className="timeline__marker-year">{t('archive.transition.timelineSlogan1')}</span>
          </div>
          <div className="timeline__date" style={{ right: '2250px' }} />
          <div className="timeline__date" style={{ right: '2280px' }} />
          <div className="timeline__date" style={{ right: '2370px' }} />
          <div className="timeline__date" style={{ right: '2400px' }} />
          <div className="timeline__date" style={{ right: '2430px' }} />
          <div className="timeline__date" style={{ right: '2460px' }} />
          <div className="timeline__date" style={{ right: '2490px' }} />
          <div className="timeline__date" style={{ right: '2520px' }} />
          <div className="timeline__date" style={{ right: '2550px' }} />
          <div className="timeline__date" style={{ right: '2700px' }} />
          <div className="timeline__date" style={{ right: '2730px' }} />
          <div className="timeline__date" style={{ right: '2760px' }} />
          <div className="timeline__marker-wrapper" style={{ right: '2844px' }}>
            <span className="timeline__marker-year">Heute</span>
          </div>
          <div
            className="timeline__date timeline__date timeline__date--active"
            style={{ right: '2844px', transform: 'translateX(-25%)' }}
          />
        </motion.div>
      </div>
      <div className="timeline__focus-wrapper">
        <span className="timeline__focus-point">
          <svg width="16" height="8" viewBox="0 0 16 8" xmlns="http://www.w3.org/2000/svg">
            <path d="M.098 6.316c-.13.13-.13.366 0 .522l1.07 1.044c.132.157.367.157.525 0l4.546-4.567c.418-.526 2.561-1.148 3.502 0l4.573 4.567c.131.131.367.131.524 0l1.044-1.043A.373.373 0 0 0 16 6.565a.373.373 0 0 0-.118-.274L10.134.549C9.767.209 9.297 0 8.8 0H7.206c-.497 0-.968.21-1.333.549L.097 6.317l.001-.001z" />
          </svg>
        </span>
      </div>
    </StyledTimeline>
  );
};

TimelineAnimation.propTypes = {
  onAnimationComplete: PropTypes.func
};

export default TimelineAnimation;
